import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { isEmpty } from 'lodash';
import { useQuery } from 'react-query';

import { setOAuthRoutes } from '../../../store/slices/userSlice';

import Button from '../../../components/Button';
import { getOAuthApi } from '../../../api/AuthenticationApi';

const GoogleIcon = 'https://otis-production.s3.eu-west-1.amazonaws.com/backoffice-assets/google_icon.svg';

const GoogleConnect = () => {
    const dispatch = useDispatch();
    const { informations, oauthRoutes } = useSelector((state) => ({
        informations: state.user.informations,
        oauthRoutes: state.user.oauthRoutes,
    }));

    const openSignInWindow = (url) => {
        window.open(url, '_parent', 'Chrome Login');
    };

    useQuery(['getOAuth'], getOAuthApi, {
        retry: 0,
        enabled: isEmpty(oauthRoutes) && informations.loaded,
        onSuccess: (response) => dispatch(setOAuthRoutes(response.data)),
    });

    return (
        <div className="f fb-100 centered">
            <Button
                type="button"
                color="secondary"
                className="px-4 w-100 mt-2"
                text={
                    <div className="f ai-c">
                        <img className="mr-8" src={GoogleIcon} />
                        Connexion Google
                    </div>
                }
                onClick={() => openSignInWindow(oauthRoutes.google)}
            />
        </div>
    );
};

export default GoogleConnect;
